"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBus = void 0;
class EventBus {
    constructor() {
        this.eventsList = {};
        this.bus = document.createElement('eventbus');
    }
    static getInstance() {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus();
        }
        return EventBus.instance;
    }
    dipatchEvent(eventName, eventArgs) {
        this.bus.dispatchEvent(new CustomEvent(eventName, { detail: eventArgs }));
    }
    addEventListener(eventName, cb) {
        const _callback = function (data) {
            data && data.detail ? cb(data.detail) : cb();
        };
        if (!this.eventsList[eventName]) {
            this.eventsList[eventName] = [_callback];
        }
        else {
            this.eventsList[eventName].push(_callback);
        }
        this.bus.addEventListener(eventName, _callback, true);
    }
    removeEventListener() {
        Object.keys(this.eventsList).forEach((event) => {
            if (this.eventsList[event]) {
                this.eventsList[event].forEach((cb, i) => {
                    this.bus.removeEventListener(event, cb, true);
                    this.eventsList[event].splice(i, 1);
                });
            }
        });
    }
}
exports.EventBus = EventBus;
